import React from 'react'

export default class Analise {
    static instance = null
    _analise = {}
    _parametro = {}
    _contraste = false

    static getInstance() {
        if (!Analise.instance) {
            Analise.instance = new Analise()
        }
        console.log("this.instance: ", this.instance)
        return this.instance
    }

    setAnalise(analise) {
        this._analise = analise
    }

    setParametro(parametro) {
        this._parametro = parametro
    }

    setContraste(contraste) {
        this._contraste = contraste
    }
    
    getAnalise() {
        return this._analise
    }

    static formatMoedaBr(valor) {
        if (!valor) return
        return valor.toLocaleString('pt-BR')
    }

    getTextToOverlay(feature) {
        if (!this._parametro) return
        if (!this._analise) return

        const analiseFeature = this._analise.itensPorIdFeature[feature.get("FID_1")]
        if (!analiseFeature) return this._parametro.nome + ": Sem dados"

        const unidade = this._parametro.nomeUnidade ? this._parametro.nomeUnidade : ''

        if (this._contraste)
            return <label>
                    {this._parametro.nome} (contraste): {Analise.formatMoedaBr(analiseFeature.valor)} {unidade}
                    <br/>
                    Contraste entre {Analise.formatMoedaBr(analiseFeature.itemSecundarioContraste.valor)} e {Analise.formatMoedaBr(analiseFeature.itemPrincipalContraste.valor)}
                </label>
        else
            switch (analiseFeature.statusLimiteQuantificacao) {
                case 'ACIMA':
                    return `${this._parametro.nome}: >${Analise.formatMoedaBr(analiseFeature.valorLimiteQuantificacao)} ${unidade}`
                case 'DENTRO':
                    return `${this._parametro.nome}: ${Analise.formatMoedaBr(analiseFeature.valor)} ${unidade}`
                case 'ABAIXO':
                    return `${this._parametro.nome}: <'${Analise.formatMoedaBr(analiseFeature.valorLimiteQuantificacao)} ${unidade}`
                default:
                    return "Sem dados"
            }
    }

    
}